const DOMAIN_LABELS: Record<string, string> = {
  code: 'Code',
  infra: 'Infra',
  docs: 'Docs',
  test: 'Test',
  planning: 'Planning',
  generic: 'Generic',
};

const INTENT_LABELS: Record<string, string> = {
  creation: 'Creation',
  enhancement: 'Enhancement',
  repair: 'Repair',
  unplanned_rework: 'Unplanned rework',
  wrong_interpretation: 'Wrong interpretation',
  exploration: 'Exploration',
  ambiguous: 'Ambiguous',
};

const PENALTY_INTENTS = new Set(['unplanned_rework', 'wrong_interpretation']);

export const DOMAIN_FILTER_OPTIONS = Object.entries(DOMAIN_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const INTENT_FILTER_OPTIONS = Object.entries(INTENT_LABELS).map(([value, label]) => ({
  value,
  label,
}));

function humanizeSlug(value: string): string {
  return value
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^\w/, (ch) => ch.toUpperCase());
}

export function formatDomainLabel(value: string | null | undefined): string {
  if (!value) return '—';
  const key = value.trim().toLowerCase();
  return DOMAIN_LABELS[key] ?? humanizeSlug(value);
}

export function formatIntentLabel(value: string | null | undefined): string {
  if (!value) return '—';
  const key = value.trim().toLowerCase().replace(/\s+/g, '_');
  return INTENT_LABELS[key] ?? humanizeSlug(value);
}

export function isPenaltyIntent(value: string | null | undefined): boolean {
  if (!value) return false;
  return PENALTY_INTENTS.has(value.trim().toLowerCase().replace(/\s+/g, '_'));
}

export function formatRoleLabel(role: string | null | undefined): string {
  switch (role) {
    case 'internal_monitor':
      return 'Internal monitor';
    case 'leadership':
      return 'Leadership';
    default:
      return 'Engineer';
  }
}
